import styled from 'styled-components';
import { rem } from 'polished';

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1190px;
  width: 100%;
  padding: 0 ${rem('24px')};
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 0 ${rem('16px')};
  }
`;
